/* unplugin-vue-components disabled */import script from "./NewsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsDialog.vue?vue&type=script&setup=true&lang=js"

import "./NewsDialog.vue?vue&type=style&index=0&id=175362d1&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-175362d1"]])

export default __exports__